<template>
    <div class="container-fluid">
        <div class="row">
            <Menu />
            <div class="col-md-10 mt-4">
                <h1> <i class="fa-sharp-duotone fa-regular fa-notes"></i> Cadastrar nova Classe
                    <RouterLink style="float:right; position:relative; top:-10px;" to="/classes" class="btn btn-primary"> <i class="fa-light fa-arrow-turn-down-left"></i> Voltar</RouterLink>
                </h1>
                <hr />
                 <div class="cont">
                    <Loading v-if="exibeLoading" />
                    <form v-if="!exibeLoading" @submit.prevent="handleClasses">
                        <div class="form-group mb-3">
                            <input type="text" v-model="nome" placeholder="Nome da Classe" class="form-control" required/>
                        </div>
                        <div class="form-group mb-3">
                            <div class="form-check form-switch">
                                <input v-model="sub" class="form-check-input" @change="verificaSubClasse()" type="checkbox" role="switch" id="flexSwitchCheckDefault">
                                <label style="margin-left:20px; position: relative; top:5px;" class="form-check-label" for="flexSwitchCheckDefault">é uma SUBCLASSE?</label>
                            </div>
                        </div>

                        <div v-if="exibeSub" class="form-group mt-4">
                            <!-- <input type="text" v-model="nome" placeholder="Nome da Classe" class="form-control" required/> -->
                             <label>Escolha a Classe Principal</label>
                             <select v-model="subClasse" class="form-control">
                                <option disabled>Selecione---</option>
                                <option  v-for="reck in exibeDados" :value="reck.id" :key="reck.id">{{ reck.name }}</option>
                             </select>
                        </div>
                        <button style="margin-left:0px;" class="btn btn-primary mt-4">Cadastrar</button>
                    </form>
                    <Alert style="margin-top:20px;" v-if="exibeAlert" :tipo="tipoS" :msg="msgS" />
            </div>
            </div>
        </div>
    </div>
    </template>

<script setup>
import { ref, onMounted } from 'vue';
import Menu from '@/components/Menu.vue';
import Alert from '@/components/Alert.vue';
import Loading from '@/components/Loading.vue';
import classes from '@/servicos/classes';

const nome = ref('')
const exibeAlert = ref(false)
const tipoS = ref('')
const msgS = ref('')
const exibeLoading = ref(false)
const exibeDados = ref([])
const exibeSub = ref(false)
const subClasse = ref('')
const sub = ref(false)

const buscaClass = async () => {
    const response = await classes.getAll()
    exibeDados.value = response.data
}

const verificaSubClasse = (event) => { 
    if(sub.value){
        exibeSub.value = true
    }  else {
        exibeSub.value = !exibeSub.value;
    }

    
}

const handleClasses = async () => {
    exibeLoading.value = true
    const response = await classes.create(nome.value, subClasse.value)
    subClasse.value = ''
    exibeSub.value = !exibeSub.value;
    if(response.data.response){
        exibeAlert.value = true
        tipoS.value = 'danger',
        msgS.value = response.response.data.message
        exibeLoading.value = false
    }

    if(response.data.id){
        exibeAlert.value = true
        tipoS.value = 'success',
        msgS.value = "Classe cadastrada com sucesso"
        nome.value = ''
        exibeLoading.value = false
    }

    setTimeout(() => {
        window.location.href='#/classes'
    }, 2000);
}

onMounted(() => {
    buscaClass()
})


</script>


    <style>
    
    h1 { color:rgba(0,0,0,.8); font-weight: 400; font-size:20px !important;}
    /* .table>:not(caption)>*>* { background-color:#1B3639;  } */
    th {color:rgba(255,255,255,.9) !important; padding:10px !important;}
    th { background-color: #1B3639 !important;}
    .cont { background:#fff; padding: 10px; border:1px solid rgba(0,0,0,.1); box-shadow:1px 2px 3px rgba(0,0,0,.4); }
    
    .form-switch .form-check-input { width:70px !important }

    </style>